

(function( ){


	//------------------------------------------------------------------------------------------------------------------------------


		var Main = function( )
		{
			var _this = this , i ;

			//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

			// この中に処理を書いていってください。

			new Nav();
			new BtnActive();
			new SubMenu();
			// new NewTicker();
			new ModalBtnSetting();

			new ScrollEnterAnime();

			window.onload = function() {
				// new NewTicker();
			}

			//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

			// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
			// リサイズイベントを綱わないようでしたら決してください。
			// var _onResize = function( )
			// {

			// }

			// _onResize( ) ;
			// FitContents.addTask( _onResize ) ;
		}


//------------------------------------------------------------------------------------------------------------------------------


var ScrollEnterAnime = function(){

	var _this = this, i;

	var js_scrollenter_anime = document.getElementsByClassName("js-scrollenter-anime");

	ScrollEnterEvent.add( js_scrollenter_anime, {
		onEnter:function(evt){
			evt.target.setAttribute("data-is-enter", "");
		}
	});

}


//------------------------------------------------------------------------------------------------------------------------------


var Nav = function()
{
	var _this = this , i;

	var _target = document.getElementsByClassName("nav__index");
	var original = _target[1];
	_target[0].def = { className:_target[0].className };
	_target[1].def = { className:_target[1].className };

	var onScroll = function(evt) {
		var scrollY = window.pageYOffset;

		var originalY = original.offsetTop;
		var parent = original.offsetParent;
		while(parent && parent != document.body) {
			originalY += parent.offsetTop;
			parent = parent.offsetParent;
		}

		originalY *= FitContents.zoomScale;

		if(originalY <= scrollY) {
			_target[0].className = _target[0].def.className + " compact";
			_target[1].className = _target[1].def.className + " compact";
		} else {
			_target[0].className = _target[0].def.className;
			_target[1].className = _target[1].def.className;
		}
	}

	window.addEventListener("scroll" , onScroll);
	onScroll();
}


//------------------------------------------------------------------------------------------------------------------------------


var BtnActive = function(){
	var _this = this, i;

	var root = document.getElementsByClassName('nav__index');
	var btnOver = root[0].getElementsByClassName('btn-privilege')[0];
	var btn = root[1].getElementsByClassName('btn-privilege')[0];

	var subBtnOver = root[0].getElementsByClassName('btn-creator')[0];
	var subBtn = root[1].getElementsByClassName('btn-creator')[0];

	btnOver.className += " active";
	btn.className += " active";

	subBtnOver.className += " active";
	subBtn.className += " active";
}


//------------------------------------------------------------------------------------------------------------------------------


var SubMenu = function(){
	var _this = this, i;

	var isOpen = false;

	var root = document.getElementsByClassName('nav__index');
	var targetOver = root[0].getElementsByClassName('privilege__container')[0];
	var target = root[1].getElementsByClassName('privilege__container')[0];

	targetOver.defClassName = targetOver.className;
	target.defClassName =target.className;

	var triggerOver = root[0].getElementsByClassName('js-nav-sub')[0];
	var trigger = root[1].getElementsByClassName('js-nav-sub')[0];

	triggerOver.defClassName = triggerOver.className;
	trigger.defClassName =trigger.className;

	// var triggerList = [triggerOver, trigger];

	$([triggerOver, trigger]).on('click', function(){
		if(isOpen) {
			isOpen = false;
			targetOver.className = targetOver.defClassName;
			target.className = target.defClassName;

			triggerOver.className = triggerOver.defClassName;
			trigger.className = trigger.defClassName;
		} else {
			isOpen = true;
			targetOver.className = targetOver.defClassName + ' opened';
			target.className = target.defClassName + ' opened';

			triggerOver.className = triggerOver.defClassName + ' opened';
			trigger.className = trigger.defClassName + ' opened';
		}
	});
}


//------------------------------------------------------------------------------------------------------------------------------


var ModalBtnSetting = function(){
	var _this = this, i;

	var isShopModalOpen = false;
	var shopOpenBtn = document.getElementsByClassName('js-shopModal__btn--open')[0];
	var shopCloseBtn = document.getElementsByClassName('js-shopModal__btn--close')[0];

	shopOpenBtn.defClassName = shopOpenBtn.className;
	shopCloseBtn.defClassName = shopCloseBtn.className;

	$(shopOpenBtn).on('click', function(){
		if(!isShopModalOpen) {
			isShopModalOpen = true;
			shopOpenBtn.className = shopOpenBtn.defClassName + ' show';
		}
	});

	$(shopCloseBtn).on('click', function(){
		if(isShopModalOpen) {
			isShopModalOpen = false;
			shopOpenBtn.className = shopOpenBtn.defClassName + ' hide';
		}
	});

	// var isShareModalOpen = false;
	// var shareOpenBtn = document.getElementsByClassName('js-shareModal__btn--open')[0];
	// var shareCloseBtn = document.getElementsByClassName('js-shareModal__btn--close')[0];

	// shareOpenBtn.defClassName = shareOpenBtn.className;
	// shareCloseBtn.defClassName = shareCloseBtn.className;

	// $(shareOpenBtn).on('click', function(){
	// 	if(!isShareModalOpen) {
	// 		isShareModalOpen = true;
	// 		shareOpenBtn.className = shareOpenBtn.defClassName + ' show';
	// 	}
	// });

	// $(shareCloseBtn).on('click', function(){
	// 	if(isShareModalOpen) {
	// 		isShareModalOpen = false;
	// 		shareOpenBtn.className = shareOpenBtn.defClassName + ' hide';
	// 	}
	// });

}


//------------------------------------------------------------------------------------------------------------------------------


var NewTicker = function(){
	var _this = this, i;

	var newsList = document.getElementsByClassName('nav__index')[1].getElementsByClassName('news__list')[0];

	var item1 = newsList.getElementsByClassName('news__text1');
	var item2 = newsList.getElementsByClassName('news__text2');

	item1.itemWidth = $(item1).width();
	$(item1).css('left', item1.itemWidth + 'px');
	item2.itemWidth = $(item2).width();

	item1.itemCount = -$(item1).width();
	item2.itemCount = 0;

	requestAnimationFrame(update);

	function updateNewsItem() {
		item1.itemWidth = $(item1).width();
		item2.itemWidth = $(item2).width();

		$(item1).css('transform', 'translateX(' + item1.itemCount + 'px)');
		$(item2).css('transform', 'translateX(' + item2.itemCount + 'px)');

		item1.itemCount -= 1;
		item2.itemCount -= 1;

		if(Math.abs(item1.itemCount) >=  Math.abs(item1.itemWidth * 2)) {
			item1.itemCount =  0;
		}

		if(Math.abs(item2.itemCount) >=  Math.abs(item2.itemWidth * 2)) {
			item2.itemCount =  0;
		}
	}

	function update() {
		// パーティクルを更新
		updateNewsItem();

		// 画面の更新
		requestAnimationFrame(update);
	}
}


//------------------------------------------------------------------------------------------------------------------------------


		window.requestAnimationFrame = 	window.requestAnimationFrame ||
										window.webkitRequestAnimationFrame ||
										function( func ){ return setTimeout( func , 1000/60 ) ; } ;


		window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
										window.webkitCancelAnimationFrame ||
										function( id ){ clearTimeout( id ) ; } ;


		document.readyState === "complete"
			? setTimeout( function(){ new Main( ) ; } , 1 )
			: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


	//------------------------------------------------------------------------------------------------------------------------------


	} )( ) ;

